'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pricingLevels = require('./pricing-levels');

var _pricingLevels2 = _interopRequireDefault(_pricingLevels);

var _couponDisplay = require('./coupon-display');

var _couponDisplay2 = _interopRequireDefault(_couponDisplay);

var _toggle = require('common/components/toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PricingArea = function (_React$Component) {
    _inherits(PricingArea, _React$Component);

    function PricingArea(props) {
        _classCallCheck(this, PricingArea);

        var _this = _possibleConstructorReturn(this, (PricingArea.__proto__ || Object.getPrototypeOf(PricingArea)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            selectedTimePeriod = _this$props.selectedTimePeriod,
            timePeriodChoices = _this$props.timePeriodChoices;

        _this.state = {
            'timePeriod': selectedTimePeriod || timePeriodChoices[1].value
        };
        return _this;
    }

    _createClass(PricingArea, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.mustContactSales) $('#contactUsButton').click();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    this.hasValidCoupon() ? this.couponDisplay() : null,
                    this.shouldDisplayToggle() ? this.toggleButton() : null
                ),
                this.errorMessage(),
                _react2['default'].createElement(
                    'div',
                    { className: 'row levels l-padding-v-60 text-center', style: { paddingTop: 0 } },
                    _react2['default'].createElement(_pricingLevels2['default'], _extends({ isMonthly: this.isMonthly(),
                        hasValidCoupon: this.hasValidCoupon(),
                        billingPlans: this.billingPlans()
                    }, this.props, this.state))
                )
            );
        }
    }]);

    return PricingArea;
}(_react2['default'].Component);

PricingArea.propTypes = {
    'signupUrl': _react.PropTypes.string,
    'pricingSource': _react.PropTypes.string,
    'paymentForm': _react.PropTypes.object.isRequired, // Serialized sfForm
    'signupForm': _react.PropTypes.object.isRequired, // Serialized sfForm
    'mustContactSales': _react.PropTypes.bool,
    'corpsLevelName': _react.PropTypes.string
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onSelection = function (selection) {
        return _this2.setState({ 'timePeriod': selection });
    };

    this.isAnnual = function () {
        return _this2.state.timePeriod == 'Y';
    };

    this.isMonthly = function () {
        return _this2.state.timePeriod == 'M';
    };

    this.isEventbrite = function () {
        return _this2.props.pricingSource === 'eventbrite';
    };

    this.billingPlans = function () {
        return _this2.props.pricingData.billing_plans;
    };

    this.pricingLevelCount = function () {
        return _this2.billingPlans().length;
    };

    this.shouldDisplayToggle = function () {
        return _this2.props.timePeriodChoices.length > 1;
    };

    this.hasValidCoupon = function () {
        var isAnnual = _this2.isAnnual();
        var isMonthly = _this2.isMonthly();
        var coupon = _this2.props.coupon;

        if (coupon) {
            var monthly_rate = coupon.monthly_rate,
                annual_rate = coupon.annual_rate;

            var invalidMonthlyRate = isMonthly && monthly_rate == 0;
            var invalidAnnualRate = isAnnual && annual_rate == 0;
            var invalidCouponCode = !coupon.coupon_code;
            if (invalidMonthlyRate || invalidAnnualRate || invalidCouponCode) return false;
        }
        return !!coupon;
    };

    this.couponDisplay = function () {
        var coupon = _this2.props.coupon;

        return _react2['default'].createElement(_couponDisplay2['default'], { couponCode: coupon.coupon_code, couponDescription: coupon.description });
    };

    this.toggleButton = function () {
        var _props = _this2.props,
            timePeriodChoices = _props.timePeriodChoices,
            selectedTimePeriod = _props.selectedTimePeriod;


        return _react2['default'].createElement(_toggle.Toggle, { choices: timePeriodChoices,
            initialSelection: selectedTimePeriod,
            onSelection: _this2.onSelection,
            isEventbrite: _this2.isEventbrite()
        });
    };

    this.errorMessage = function () {
        var errors;
        if (_this2.props.errors) {
            var errorMsg = 'Sorry, we could not process your payment.';
            if (_this2.props.errors['payment[submit]']) {
                errorMsg += ' ' + _this2.props.errors['payment[submit]'];
            }
            if (_this2.props.errors['payment[cc_number]']) {
                errorMsg += ' ' + _this2.props.errors['payment[cc_number]'];
            }
            if (_this2.props.errors['payment[0]']) {
                errorMsg += ' ' + _this2.props.errors['payment[0]'];
            }
            errors = _react2['default'].createElement(
                'div',
                { 'data-test-id': 'errors', className: 'row text-center l-padding-v-20' },
                _react2['default'].createElement(
                    'p',
                    { className: 'c-red' },
                    errorMsg
                )
            );
        }
        return errors;
    };
};

module.exports = PricingArea;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/index.jsx
 ** module id = 1048
 ** module chunks = 0
 **/